var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaAereoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.99918 19.88933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b2a28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.99918,9.27929v1.33a.51556.51556,0,0,1-.28.46l-1.93.91a2.89679,2.89679,0,0,1-1.26.28h-3l-5.27,7.16a1.39181,1.39181,0,0,1-1.02.47,1.35717,1.35717,0,0,1-.71-.21,1.30553,1.30553,0,0,1-.52-1.57l.43-2.28.3-1.61.18006-.96h2.21l-.45.93a.63688.63688,0,0,0-.06.18h1.09l.54-1.11.14-.28a.53009.53009,0,0,0-.02-.49.5205.5205,0,0,0-.43-.24h-5.38v.01h-.1l-2.7,1.74a1.18086,1.18086,0,0,1-.63.19,1.11681,1.11681,0,0,1-.78-.33,1.121,1.121,0,0,1-.19-1.39l1.46-2.52-1.46-2.52a1.11914,1.11914,0,0,1,.19-1.39,1.11966,1.11966,0,0,1,1.41-.14l2.7,1.74h5.48a.52047.52047,0,0,0,.43-.24.5507.5507,0,0,0,.02-.5l-.13-.27-.55-1.11h-1.09a.63682.63682,0,0,0,.06.18l.45.93h-2.21l-.18006-.95-.54-2.9-.19-.99a1.30158,1.30158,0,0,1,.52-1.57,1.30207,1.30207,0,0,1,1.7.22l5.3,7.2h3a2.89674,2.89674,0,0,1,1.26.28l1.93.91A.51178.51178,0,0,1,19.99918,9.27929Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaAereoFill);
export default __webpack_public_path__ + "static/media/iconaAereoFill.af91a3f16f8d3c6a8e62dba26b6749cf.svg";
export { ForwardRef as ReactComponent };